import React, { useState } from 'react'
import queryString from 'query-string';
import { useEffect } from 'react';
import axios from 'axios'
import { Button } from 'react-bootstrap';

const ReturnEmailPage = () => {

    const codeUrl = queryString.parse(window.location.search).code

    const [data, setData] = useState(null)

    const [isAlertSuccess, setIsAlertSuccess] = useState(false);

    useEffect(() => {
        if (codeUrl) {
            axios.post(`${process.env.REACT_APP_API_BASE}/return-email/check-code`, {
                code: codeUrl
            })
                .then(response => {
                    if (response.data) {
                        setData(response.data)
                    }
                    else {
                        window.location.replace('/')
                    }
                })
                .catch(err => {
                    console.error(err);

                })
        }
    }, [codeUrl])

    const handleConfirm = () => {
        axios.post(`${process.env.REACT_APP_API_BASE}/return-email/change`, data)
            .then(response => {
                if (response.data.res === 'Success') {
                    setIsAlertSuccess(true)
                }
            })
            .catch(err => {
                console.error(err);

            })
    }

    return (
        <div>
            {
                data &&
                <div>
                    {
                        isAlertSuccess ?
                            <div className='h5 mb-3 mt-3' >
                                Email успешно изменен. Выслали на старую почту логин и пароль
                            </div>
                            :
                            <Button className='btn-primary' onClick={handleConfirm}>
                                Подтвердить изменение почты
                            </Button>
                    }
                </div>
            }
        </div>
    )
}

export default ReturnEmailPage